import * as React from 'react'
import { Header, BillToLocation, ServiceLocations } from './atoms'
import { getStyles } from './hooks'
import { MatchProps } from './typings'

import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

export const Match: React.FC<MatchProps> = (props) => {
  const styles = getStyles(useTheme())
  const { billToLocation, dispatch, label, state } = props
  return (
    <>
      <Box sx={styles.pageWrapper}>
        <Header styles={styles} label={label} />

        <BillToLocation
          {...props}
          styles={styles}
          state={state}
          dispatch={dispatch}
          location={billToLocation}
        />

        <ServiceLocations
          {...props}
          classes={styles}
          state={state}
          dispatch={dispatch}
        />
      </Box>
    </>
  )
}
Match.displayName = 'Match'
